var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mapcomponent" } }, [
    !_vm.cookiesAllowed
      ? _c("div", { staticClass: "no-cookies" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _vm.currentLang === "it"
              ? _c("span", [
                  _vm._v(
                    "\n\t\t  Mappa stradale fornita da OpenStreetMap bloccata in assenza di tua autorizzazione.\n\t\t  Per vederla, modifica le tue impostazioni sui cookie\n\t\t  e dai il consenso a OpenStreetMap.\n\t\t"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentLang === "en"
              ? _c("span", [
                  _vm._v(
                    "\n\t\t  The map provided by OpenStreetMap was blocked, because your authorization is missing.\n\t\t  To see it, please update your cookie preferences\n\t\t  and allow OpenStreetMap,\n\t\t"
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cookiesAllowed
      ? _c("div", [
          _c("div", { attrs: { id: "leaflet-container" } }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                id: "explore-button",
                type: "button",
                "data-bs-toggle": "offcanvas",
                "data-bs-target": "#mapmenu",
                "aria-controls": "mapmenu",
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "bi bi-list",
                  staticStyle: { "margin-bottom": "3px" },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "23",
                    fill: "currentColor",
                    viewBox: "0 0 16 16",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z",
                    },
                  }),
                ]
              ),
              _vm._v(
                "\n\n\t\t\t" +
                  _vm._s(_vm.filtersMap[_vm.currentLang]["lbl-esplora"]) +
                  "\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "breadcrumb-container" } }, [
            _c("span", [_vm._v(_vm._s(_vm.currentBreadcrumbs))]),
            _vm._v(" "),
            _vm.currentInfoTarget > 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-primary",
                    on: { click: _vm.openInfo },
                  },
                  [_vm._v("Info")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "offcanvas offcanvas-start",
              attrs: {
                tabindex: "-1",
                id: "mapmenu",
                "aria-labelledby": "mapmenu",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "offcanvas-body",
                  attrs: { id: "map-offcanvas-left" },
                },
                [
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "offcanvas",
                      "aria-label": "Chiudi",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "leaflet-layers" } }, [
                    _c("div", [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.filtersMap[_vm.currentLang]["lbl-timeline"]
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "to-lightbox",
                          attrs: {
                            href: "/wp-content/themes/mvmr/static/timeline.jpg",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang][
                                  "lbl-timelinelink"
                                ]
                              ) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.filtersMap[_vm.currentLang]["lbl-esplora"])
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMode,
                              expression: "currentMode",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "radio", value: "1", id: "mode-1" },
                          domProps: { checked: _vm._q(_vm.currentMode, "1") },
                          on: {
                            change: function ($event) {
                              _vm.currentMode = "1"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "mode-1" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang]["lbl-tracciati"]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMode,
                              expression: "currentMode",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "radio", value: "2", id: "mode-2" },
                          domProps: { checked: _vm._q(_vm.currentMode, "2") },
                          on: {
                            change: function ($event) {
                              _vm.currentMode = "2"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "mode-2" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang]["lbl-percorsi"]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMode,
                              expression: "currentMode",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "radio", value: "3", id: "mode-3" },
                          domProps: { checked: _vm._q(_vm.currentMode, "3") },
                          on: {
                            change: function ($event) {
                              _vm.currentMode = "3"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "mode-3" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang]["lbl-storie"]
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "leaflet-walls" } }, [
                    _vm.currentMode == 1
                      ? _c("div", { attrs: { id: "epoch-select" } }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang]["lbl-mura"]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentEpoch,
                                  expression: "currentEpoch",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                value: "1",
                                id: "epoch-1",
                              },
                              domProps: {
                                checked: _vm._q(_vm.currentEpoch, "1"),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentEpoch = "1"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "epoch-1" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.filtersMap[_vm.currentLang][
                                      "lbl-serviane"
                                    ]
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentEpoch,
                                  expression: "currentEpoch",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                value: "2",
                                id: "epoch-2",
                              },
                              domProps: {
                                checked: _vm._q(_vm.currentEpoch, "2"),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentEpoch = "2"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "epoch-2" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.filtersMap[_vm.currentLang][
                                      "lbl-aureliane"
                                    ]
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentEpoch,
                                  expression: "currentEpoch",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                value: "3",
                                id: "epoch-3",
                              },
                              domProps: {
                                checked: _vm._q(_vm.currentEpoch, "3"),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentEpoch = "3"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "epoch-3" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.filtersMap[_vm.currentLang][
                                      "lbl-vaticane"
                                    ]
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentEpoch,
                                  expression: "currentEpoch",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                value: "4",
                                id: "epoch-4",
                              },
                              domProps: {
                                checked: _vm._q(_vm.currentEpoch, "4"),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentEpoch = "4"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "epoch-4" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.filtersMap[_vm.currentLang][
                                      "lbl-urbaniane"
                                    ]
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "leaflet-itineraries" } }, [
                    _vm.currentMode == 2
                      ? _c(
                          "div",
                          { attrs: { id: "itinerary-select" } },
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(
                                  _vm.filtersMap[_vm.currentLang][
                                    "lbl-percorsi"
                                  ]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.allItineraries, function (item) {
                              return _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentItinerary,
                                      expression: "currentItinerary",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "radio",
                                    id: "itinerary-" + item.id,
                                  },
                                  domProps: {
                                    value: item.id,
                                    checked: _vm._q(
                                      _vm.currentItinerary,
                                      item.id
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.currentItinerary = item.id
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "itinerary-1" },
                                  },
                                  [_vm._v(_vm._s(item.description))]
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "leaflet-filters" } }, [
                    _vm.currentMode == 3
                      ? _c("div", { attrs: { id: "topics-select" } }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.filtersMap[_vm.currentLang]["lbl-temi"]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentFilters,
                                  expression: "currentFilters",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "1",
                                id: "theme-1",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.currentFilters)
                                  ? _vm._i(_vm.currentFilters, "1") > -1
                                  : _vm.currentFilters,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.currentFilters,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.currentFilters = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.currentFilters = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.currentFilters = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "theme-1" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.filtersMap[_vm.currentLang]["1"])
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentFilters,
                                  expression: "currentFilters",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "2",
                                id: "theme-2",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.currentFilters)
                                  ? _vm._i(_vm.currentFilters, "2") > -1
                                  : _vm.currentFilters,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.currentFilters,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "2",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.currentFilters = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.currentFilters = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.currentFilters = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "theme-2" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.filtersMap[_vm.currentLang]["2"])
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "go-holder" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { id: "go-button" },
                        on: { click: _vm.vai },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.filtersMap[_vm.currentLang]["lbl-vai"])
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "offcanvas offcanvas-end popup-category",
              attrs: {
                tabindex: "-1",
                id: "poi-popup-holder",
                "aria-labelledby": "poi-popup-holder-lbl",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "offcanvas-header",
                  class: _vm.popupCategoryClass,
                },
                [
                  _c("div", { staticClass: "category-name ico-lbl" }, [
                    _c("img", {
                      staticClass: "ico category-ico",
                      attrs: { src: _vm.popupIcon },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "lbl category-lbl" }, [
                      _vm._v(_vm._s(_vm.popupCategoryName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "offcanvas",
                      "aria-label": "Chiudi",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "offcanvas-header poi-popup-holder-title-holder",
                  class: _vm.popupCategoryClass,
                },
                [
                  _c("h5", {
                    staticClass: "offcanvas-title",
                    attrs: { id: "poi-popup-holder-lbl" },
                    domProps: { innerHTML: _vm._s(_vm.popupTitle) },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "offcanvas-body",
                  class: _vm.popupCategoryClass,
                },
                [
                  !_vm.isPopupReady
                    ? _c("div", { attrs: { id: "popup-spinner" } }, [
                        _vm._v("Caricamento in corso..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPopupReady
                    ? _c("div", {
                        attrs: { id: "popup-body" },
                        domProps: { innerHTML: _vm._s(_vm.popupBody) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "sep",
                    class: _vm.popupCategoryClass,
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fa-stack fa-1x" }, [
      _c("i", {
        staticClass: "far fa-slash fa-stack-1x",
        staticStyle: { color: "red" },
      }),
      _vm._v(" "),
      _c("i", { staticClass: "far fa-cookie-bite fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#top", id: "go-up" } }, [
      _c("img", { attrs: { src: require("../images/frecce-giu-tondo.png") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#footer", id: "go-down" } }, [
      _c("img", { attrs: { src: require("../images/frecce-giu-tondo.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }